<template>
  <div class="domainname-container">
    <div
      class="top"
      :style="{'background-image': 'url(' + hostLink.bg1 + '.png)'}"
      v-for="hostLink in hostLink"
      :key="hostLink.id"
    >
      <h3>
        {{$t(hostLink.describe1)}}
        <span>{{hostLink.url}}</span>
      </h3>
      <h4>{{$t(hostLink.describe2)}}</h4>
      <!-- <h4 v-if="!this.$device.ios && !this.$device.android">{{$t(hostLink.url)}}</h4> -->
    </div>
    <div
      class="bottom"
      :style="{'background-image': 'url(' + hostLink.bg2 + '.png)'}"
      v-for="hostLink in hostLink"
      :key="hostLink.key"
    >
      <span>{{$t(hostLink.describe3)}}</span>
      <p>
        <a
          v-for="domainLink in domainLinks"
          :key="domainLink.id"
          :href="domainLink.url"
        >{{domainLink.text}}</a>
      </p>
    </div>
    <div
      v-for="hostLink in hostLink"
      :key="hostLink.key"
      class="bottom-add"
    >{{$t(hostLink.describe2)}}</div>
  </div>
</template>

<script>
export default {
  name: "DomainName",
  data() {
    return {
      domainLink: this.domainLinks,
      hostLink: this.hostLink,
    };
  },
  // methods: {
  //   getUrl() {
  //     // let hostLocation = window.location.href.indexOf("hhpoker777.com");
  //     let hostLocation = window.location.href.indexOf(
  //       "http://192.168.9.69:8080/"
  //     );
  //     // console.log("url");
  //     // console.log(hostLocation);

  //     if (hostLocation > -1) {
  //       return 1;
  //       // $(".top_text").addClass("host_show");
  //       // $('.location_img').addClass('host_show')
  //       // $(".top").css("justify-content", "space-between")
  //     }
  //   },
  // },
  created() {
    // console.log(!this.$device.ios && !this.$device.android, "====");
    // console.log(this.getUrl());
    // this.getUrl();
    // console.log(this.$device);
  },
};
</script>

<style lang="less" scoped>
// ~@ 代表src路径
@import "~@/assets/mixin.less";
@import "~@/assets/var.less";
.domainname-container {
  .top {
    .flex-box(space-between,flex-end);
    height: 10rem;
    padding: 0 4rem;
    background-image: url("~@/assets/mipoker/domain-bg1.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    h3 {
      font-size: 3.2rem;
      line-height: 10rem;
      span {
        color: @lightWordsActive;
      }
    }
    h4 {
      // font-size: 2rem;
      color: darken(@lightWordsActive2, 30%);
      flex: 1;
      text-align: right;
      // line-height: 2;
    }
  }
  .bottom {
    .flex-box(flex-start);
    align-items: flex-start;
    min-height: 5rem;
    padding: 1rem 4rem;
    background-image: url("~@/assets/mipoker/domain-bg2.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    p {
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      a {
        cursor: pointer;
        color: @lightWordsActive2;
        padding: 0 0.8rem;
      }
    }
  }
  .bottom-add {
    .flex-box(center,center);
    text-align: center;
    height: 6rem;
    padding: 1rem 4rem;
    background-image: url("~@/assets/mipoker/domain-bg3-m.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    color: darken(@lightWordsActive2, 28%);
  }
}
</style>